import React from 'react';

interface ContentRadioProps {
  checked: boolean;
  disabled?: boolean;
  value: 'copy' | 'reuse' | 'doNotUse';
  onChange: () => void;
}

const LABELS = {
  copy: 'Copy',
  doNotUse: 'Do Not Use',
  reuse: 'Reuse',
};

const ContentRadio = ({ checked, disabled = false, value, onChange }: ContentRadioProps) => (
  <label
    className="tw-flex tw-items-center tw-mb-2 tw-ml-2"
  >
    <input
      checked={checked}
      disabled={disabled}
      type="radio"
      value={value}
      onChange={onChange}
    />
    <span>{LABELS[value]}</span>
  </label>
);

export default ContentRadio;
